// libs
import { connect } from 'react-redux';
import get from 'lodash/get';

// components
import Api from './Api';

// redux
import { fetchPDPData as _fetchPDPData } from 'shared/store/details/services';
import { updateStatusCode as _updateStatusCode } from 'shared/store/app/actions';
import { getSSRHeaders, getStoreId, app } from 'shared/store/app/selectors';
import {
  getErrorSKU,
  getFetchingSKU,
  getProductId,
  getProductSKU,
  isFetching,
} from 'shared/store/details/selectors';

import { resetErrorSku as _resetErrorSku } from 'shared/store/details/actions';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';
import { getABExperimentVariant } from '@nykaa/experiment-sdk/store/selectors';
import { MULTI_SELLER_EXPERIMENT_ID } from 'shared/constants/multiSeller';
import { isMultiSellerEligible } from 'shared/helpers/multiSeller';

const mapStateToProps = (state: any, ownProps: any) => {
  const { isMobile = false } = ownProps;
  const multiSellerEnabled = getRemoteConfig(state, 'multiSellerEnabled', false);
  const multiSellerConfig = getRemoteConfig(state, 'multiSeller');
  const { isEligible: isMultiSellerExperimentEligible, variant: multiSellerVariant } =
    getABExperimentVariant(state, MULTI_SELLER_EXPERIMENT_ID);

  const isMultiSellerEligibleForPDP = isMultiSellerEligible({
    multiSellerEnabled,
    multiSellerConfig,
    isEligible: isMultiSellerExperimentEligible,
    variant: multiSellerVariant,
    surface: 'pdp',
  });

  return {
    storeId: getStoreId(state),
    productID: getProductId(state),
    productSKU: getProductSKU(state),
    isFetching: isFetching(state),
    fetchingSKU: getFetchingSKU(state),
    ssrHeaders: getSSRHeaders(state),
    cookies: app(state).cookies,
    errorSKU: getErrorSKU(state),
    isPriceReveal: get(
      getRemoteConfig(state, 'priceReveal'),
      isMobile ? 'mobile' : 'desktop',
      false
    ),
    isMultiSellerEligible: isMultiSellerEligibleForPDP
  };
};

const mapDispatchToProps = {
  fetchPDPData: _fetchPDPData,
  updateStatusCode: _updateStatusCode,
  reset: _resetErrorSku,
};

export default connect(mapStateToProps, mapDispatchToProps)(Api);
